import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    url: String,
    scheduleId: Number,
    mode: String,
    globalEnabled: Boolean,
    tenantSlug: String,
  };

  #requestId = 0;

  toggle() {
    const isActive = this.globalEnabledValue
      ? this.modeValue !== "mute"
      : this.modeValue === "opt_in";
    const next = isActive
      ? this.globalEnabledValue
        ? "mute"
        : "clear"
      : this.globalEnabledValue
        ? "clear"
        : "opt_in";
    const requestId = ++this.#requestId;
    this.#patch({ stream_schedule_id: this.scheduleIdValue, mode: next }).then(() => {
      if (requestId !== this.#requestId) return;
      this.modeValue = next === "clear" ? "" : next;
      this.#render();
    });
  }

  #render() {
    const icon = this.element.querySelector("i");
    if (!icon) return;
    icon.className = "fa-regular";
    if (this.globalEnabledValue) {
      icon.classList.add(this.modeValue === "mute" ? "fa-bell-slash" : "fa-bell");
    } else {
      icon.classList.add(this.modeValue === "opt_in" ? "fa-bell" : "fa-bell-slash");
    }
  }

  async #patch(body) {
    const r = await fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": this.#csrfToken(),
      },
      body: JSON.stringify({ ...body, tenant_slug: this.tenantSlugValue }),
    });
    return r.json();
  }

  #csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content || "";
  }
}
